import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { Supplier } from '../api/models/SupplierModel'
import { suppliersAPI } from '../api/supplier/suppliersAPI'

export const getSuppliers: any = createAsyncThunk(
  'suppliers/getSuppliers',
  async (self, { rejectWithValue }) => {
    try {
      var suppliers: any = []
      const response = await suppliersAPI.getSuppliers()
      response.data.value.forEach((supplier) => {
        suppliers.push(new Supplier(supplier))
      })
      return suppliers
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

const mapAddress = (address: any, type: any) => {
  if (address) {
    return {
      addressType: type,
      ...address,
    }
  }
  return undefined
}

const mapSupplier = (supplier: any) => {
  const primary = mapAddress(supplier.registration.address, 'Primary')
  const correspondence = mapAddress(
    supplier.contact.correspondenceAddress,
    'CorrespondenceAddress',
  )
  return {
    accountNumber: supplier.registration.accountNumber,
    accountManager: supplier.billing.accountManager,
    registrationNumber: supplier.registration.registrationNumber,
    companyName: supplier.registration.companyName,
    alias: supplier.registration.alias,
    addresses: [primary && primary, correspondence && correspondence],
    // primaryContact: supplier.contact.primaryContact,
    // secondaryContact: supplier.contact.secondaryContact,
    // billingContact: supplier.contact.billingContact,
    billing: {
      accountNumber: supplier.billing.accountNumber,
      sortCode: supplier.billing.sortCode,
      vATRegistered: supplier.billing.vATRegistered,
      vATNumber: supplier.billing.vATNumber,
      billingTermTypeName: supplier.billing.billingTermTypeName,
      billingTermValue: +supplier.billing.billingTermValue,
      currency: supplier.billing.currency,
    },
    status: 'OnBoarding',
    regionName: supplier.contact.regionName,
    services: supplier.services.services,
    termsAndConditions: supplier.services.termsAndConditions,
  }
}

export const createSupplier: any = createAsyncThunk(
  'suppliers/createSupplier',
  async (supplier, { rejectWithValue }) => {
    try {
      const mappedSupplier: any = mapSupplier(supplier)
      const response = await suppliersAPI.createSupplier(mappedSupplier)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

const suppliersSlice = createSlice({
  name: 'suppliers',
  initialState: {
    error: null,
    registration: undefined,
    contact: undefined,
    billing: undefined,
    services: undefined,
  },
  reducers: {
    createRegistration(state, action) {
      const newState = {
        ...action.payload,
      }
      state.registration = newState
    },
    createServices(state, action) {
      const newState = {
        ...action.payload,
      }
      state.services = newState
    },
    createContact(state, action) {
      const newState = {
        ...action.payload,
      }
      state.contact = newState
    },
    createBilling(state, action) {
      const newState = {
        ...action.payload,
      }
      state.billing = newState
    },
    setSupplier(state: any, action) {
      const newState = {
        ...action.payload,
      }
      state.supplier = newState
    },
    resetSupplierStore(state: any) {
      state.error = null
      state.registration = undefined
      state.contact = undefined
      state.billing = undefined
      state.services = undefined
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSuppliers.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(createSupplier.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
  },
})

export const {
  createServices,
  createRegistration,
  createContact,
  createBilling,
  setSupplier,
  resetSupplierStore,
} = suppliersSlice.actions

export default suppliersSlice.reducer
